'use client';
import { getUrlGtm } from '@/utils/gtmUtils';
import classNames from 'classnames';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoButton from 'eco-design/base/eco-button';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoLink from 'eco-design/base/eco-link';
import { handle_GTM_33 } from 'gtmEvent/33';
import { handle_GTM_34 } from 'gtmEvent/34';
import { handle_GTM_52 } from 'gtmEvent/52';
import { handle_GTM_64 } from 'gtmEvent/64';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import './index.scss';

export default function Content({ id, data = {}, initIndex = 0, isEditStatus = false }: ContentServerProps) {
    const { label, title, desc, labelType, list = [] } = data;
    const { locale = 'us' } = getLocal();
    const prefixCls = 'index-tab-list-a';
    const prefixClsA = 'index-tab-list-a-box1';
    const prefixClsB = 'index-tab-list-a-box2';
    const [activeIndexA, setActiveIndexA] = useState(initIndex);
    const firstItemA = list[isEditStatus ? initIndex : activeIndexA] || {};
    const [itemsB, setItemsB] = useState(firstItemA.list2 || []);
    const recommended_title = list[activeIndexA]?.recommended_title || ''; //推荐标题
    const tabChangeA = (itemA: any, index: number) => {
        setActiveIndexA(index);
        setItemsB(itemA.list2 || []);

        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: title,
            button_name: itemA.tab_name,

            __btn_id1: `juzheng-tabs-item-${index}`,
            __btn_id2: itemA.tab_name,
            __btn_type: 'common',
        });
    };
    const handleGTM = (url: string, text: string) => {
        const name = 'image';
        const regex1 = /^https:\/\/[a-z]{2}\.ecoflow\.com\/(?:cart|checkouts)\//i;
        const regex2 = /^https:\/\/[a-z]{2}\.ecoflow\.com\//i;
        const regex3 = /^(https:\/\/)?www\.ecoflow\.com\/[a-z]{2}\//i;
        if (regex1.test(url)) {
            // 1. checkout shopify结账页
            handle_GTM_34({
                button_name: `${text}_${name}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        } else if (regex2.test(url)) {
            // 2. shopify 其他页
            handle_GTM_33({
                product_name: name,
                position: `index_IndexTabListA_${id}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        } else if (regex3.test(url)) {
            // 3. 官网网页
            handle_GTM_52({
                list_name: title,
                product_name: name,
                button_name: text,
                position: `index_IndexTabListA_${id}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        } else {
            // 4. 其他
            handle_GTM_64({
                list_name: title,
                button_name: text,
                position: `index_IndexTabListA_${id}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        }
    };
    useEffect(() => {
        setItemsB(firstItemA.list2 || []);
    }, [data, firstItemA, firstItemA.list2]);

    return (
        <GloLayout className={`editor-index-tab-list-a`} id={id} data={data} floorName="index-tab-list-a">
            <div className="eco-content-v2 index-tab-list-a-info">
                {labelType === 'DIY' && label && <p className={`${prefixCls}-label`}>{label}</p>}
                {labelType === 'NO1' && (
                    <div className={`${prefixCls}-label default`}>
                        <span>Global</span>
                        <img src="https://websiteoss.ecoflow.com/upload/image/1764140591441/icon.png" draggable="false" />
                        <span>Portable Power Station in Sales*</span>
                    </div>
                )}
                <h2 className={`${prefixCls}-title`}>{title}</h2>
                <p className={`${prefixCls}-desc`}>{desc}</p>
            </div>

            <Swiper className={`${prefixCls}-tabs-list`} slidesPerView="auto" initialSlide={initIndex}>
                {list.map((itemA: any, index: number) => {
                    const itemClassesA = classNames({
                        [`${prefixCls}-tabs-item`]: true,
                        [`${prefixCls}-tabs-item-active`]: activeIndexA === index,
                    });
                    return (
                        <SwiperSlide key={index} className={`${itemClassesA}`}>
                            <div
                                className={`${prefixCls}-tabs-item-box GtmModuleData-btn-common juzheng-tabs-item-${index}`}
                                data-btn-id={itemA.tab_name}
                                onClick={() => tabChangeA(itemA, index)}
                            >
                                {itemA.tab_name}
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            <div className="eco-content-v2">
                <div className={prefixClsA}>
                    <div
                        className={classNames({
                            [`${prefixClsA}-item`]: true,
                            [`${prefixClsA}-theme-${firstItemA.theme}`]: firstItemA.theme,
                        })}
                    >
                        <div
                            className={`${prefixClsA}-item-img`}
                            onClick={() => {
                                if (firstItemA?.lHref) {
                                    handleGTM(firstItemA?.lHref, 'image');
                                    window.open(firstItemA.lHref, '_blank');
                                    // 1. checkout => https://us.ecoflow.com/checkouts/cn/hWN6bOi6WvZ1r1ECVcafOoKO/en-us?_r=AQABFnGHZn-cZ1lZW7AM6Pa19wIXIWn4XUcLF8yGzrkL
                                }
                            }}
                        >
                            <EcoImgVideo isVideo={firstItemA?.isVideo} pc={firstItemA?.pc} h5={firstItemA?.h5} />
                        </div>
                        <div className={`${prefixClsA}-item-msg`}>
                            <div className={`${prefixClsA}-item-info`}>
                                {firstItemA?.label && <div className={`${prefixClsA}-item-label`}>{firstItemA?.label}</div>}
                                {firstItemA?.title && <div className={`${prefixClsA}-item-title`}>{firstItemA?.title}</div>}
                                {firstItemA?.desc && <div className={`${prefixClsA}-item-desc`}>{firstItemA?.desc}</div>}
                            </div>
                            <div
                                className={`${prefixClsA}-item-box-btn`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                            >
                                <EcoButton
                                    className={`juzhen-content-btn-l-${activeIndexA} GtmModuleData-btn-href`}
                                    lTheme={firstItemA?.theme}
                                    lType="text"
                                    lHref={firstItemA?.lHref}
                                    lChildren={firstItemA?.lBtnContent}
                                    lIsWithRightArrow={true}
                                    lDataLayer={{
                                        ...getUrlGtm(firstItemA.lHref, locale, {
                                            button_name: firstItemA?.lBtnContent,
                                            product_name: firstItemA?.title,
                                            list_name: title,
                                        }),
                                        position: `Homepage_middlebanner_2_l_${activeIndexA + 1}`,

                                        __btn_id1: `juzhen-content-btn-l-${activeIndexA}`,
                                        __btn_id2: firstItemA?.lHref,
                                        __btn_type: 'href',
                                    }}
                                />
                                <EcoButton
                                    className={`juzhen-content-btn-r-${activeIndexA} GtmModuleData-btn-href`}
                                    lTheme={firstItemA?.theme}
                                    lType="text"
                                    lHref={firstItemA?.rHref}
                                    lChildren={firstItemA?.rBtnContent}
                                    lIsWithRightArrow={true}
                                    lDataLayer={{
                                        ...getUrlGtm(firstItemA.rHref, locale, {
                                            button_name: firstItemA?.rBtnContent,
                                            product_name: firstItemA?.title,
                                            list_name: title,
                                        }),
                                        position: `Homepage_middlebanner_2_r_${activeIndexA + 1}`,

                                        __btn_id1: `juzhen-content-btn-r-${activeIndexA}`,
                                        __btn_id2: firstItemA?.rHref,
                                        __btn_type: 'href',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {recommended_title && (
                <div className={`eco-content-v2`}>
                    <div className={`${prefixClsB}-title`}>{recommended_title}</div>
                </div>
            )}
            {itemsB?.length > 0 && (
                <ul className={`${prefixClsB}-list length-${itemsB.length}`}>
                    {itemsB.map((itemA: any, index: number) => {
                        if (!itemA) {
                            return null;
                        }
                        const { label, title, desc, theme = 'white' } = itemA;
                        return (
                            <li key={index} className={`${prefixClsB}-item length-${itemsB.length}`}>
                                <EcoLink
                                    className={`${prefixClsB}-item-img juzheng-img-${activeIndexA}-${index} GtmModuleData-btn-href`}
                                    href={itemA.lHref || itemA.rHref}
                                    target="_blank"
                                    dataLayer={{
                                        ...getUrlGtm(itemA.lHref || itemA.rHref, locale, {
                                            list_name: recommended_title,
                                            product_name: title,
                                            button_name: 'product-img',
                                        }),
                                        position: `Homepage_ProductList_1_img`,

                                        __btn_id1: `juzheng-img-${activeIndexA}-${index}`,
                                        __btn_id2: itemA.lHref || itemA.rHref,
                                        __btn_type: 'href',
                                    }}
                                >
                                    <EcoImgVideo isVideo={itemA.isVideo} pc={itemA.pc} h5={itemA.h5} />
                                </EcoLink>
                                <div className={`${prefixClsB}-item-msg`}>
                                    <div className={`${prefixClsB}-item-info`}>
                                        {label && <div className={`${prefixClsB}-item-label`}>{label}</div>}
                                        {title && <div className={`${prefixClsB}-item-title`}>{title}</div>}
                                        {desc && <div className={`${prefixClsB}-item-desc`}>{desc}</div>}
                                    </div>
                                    <div className={`${prefixClsB}-item-box-btn`}>
                                        <EcoButton
                                            className={`${prefixClsB}-item-box-btn-item juzheng-more-${activeIndexA}-${index} GtmModuleData-btn-href`}
                                            lTheme="black"
                                            lType="filled"
                                            lRadius="ellipse"
                                            lHref={itemA.lHref}
                                            lChildren={itemA.lBtnContent}
                                            lDataLayer={{
                                                ...getUrlGtm(itemA.lHref, locale, {
                                                    list_name: recommended_title,
                                                    product_name: title,
                                                    button_name: itemA.lBtnContent,
                                                }),
                                                position: `Homepage_ProductList_1_leftBtn`,

                                                __btn_id1: `juzheng-more-${activeIndexA}-${index}`,
                                                __btn_id2: itemA.lHref,
                                                __btn_type: 'href',
                                            }}
                                        />
                                        <EcoButton
                                            className={`${prefixClsB}-item-box-btn-item juzheng-buy-${activeIndexA}-${index} GtmModuleData-btn-href`}
                                            lTheme="black"
                                            lType="outlined"
                                            lRadius="ellipse"
                                            lHref={itemA.rHref}
                                            lChildren={itemA.rBtnContent}
                                            lDataLayer={{
                                                ...getUrlGtm(itemA.rHref, locale, {
                                                    list_name: recommended_title,
                                                    product_name: title,
                                                    button_name: itemA.rBtnContent,
                                                }),
                                                position: `Homepage_ProductList_1_rightBtn`,

                                                __btn_id1: `juzheng-buy-${activeIndexA}-${index}`,
                                                __btn_id2: itemA.rHref,
                                                __btn_type: 'href',
                                            }}
                                        />
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}
        </GloLayout>
    );
}
